import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export interface SegmentedToggleOption<T = unknown> {
  value: T;
  label: string;
  disabled?: boolean;
  disabledTooltip?: string;
  showDot?: boolean;
}

@Component({
  selector: 'app-segmented-toggle',
  templateUrl: './segmented-toggle.component.html',
  styleUrls: ['./segmented-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SegmentedToggleComponent<T = unknown> {
  readonly options = input<SegmentedToggleOption<T>[]>([]);
  readonly value = input<T | null>();
  readonly disabled = input<boolean>(false);
  readonly valueChange = output<T>();

  onChange(value: T): void {
    this.valueChange.emit(value);
  }
}
